import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {isSalesCrmPath} from '../config/config';
import Analytics from '../component/analytics/Analytics';
import AiAgent from '../component/aiAgent/AiAgent';
import useIsAiAgentFabRendered from '../hooks/useIsAiAgentFabRendered';

const RootLayout = () => {
    const isAiAgentRendered = useIsAiAgentFabRendered();
    const internalSales = isSalesCrmPath(useLocation().pathname);

    return (
        <>
            <Analytics />
            <Outlet />
            {isAiAgentRendered && !internalSales && <AiAgent />}
        </>
    );
};

export default RootLayout;
